"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseInfo = getBaseInfo;
exports.getDistancePattern = getDistancePattern;
exports.getNumberPattern = getNumberPattern;
exports.initBase = initBase;
exports.isEN = isEN;

var _ = require("../");

function initBase() {
  return new Promise(function (resolve, reject) {
    return resolve();
  });
}

function getDistancePattern() {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  var distance;

  try {
    distance = _._apollo.distance[_._locale] || _._apollo.distance["default"];
  } catch (e) {}

  return distance;
}

function getBaseInfo() {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  return {
    locale: _._locale
  };
}

function getNumberPattern() {
  if (!_._locale) {
    throw Error("Elvish Error: please call init function with local parameter first");
  }

  return _._apollo.numberV2[_._locale] || _._apollo.numberV2["default"];
} // 判断是否英国，英制，其他英制国家apollo没配


function isEN(country) {
  var countryFromLocal = _._locale.toUpperCase().match(/[A-Z]{2}$/);

  if (!countryFromLocal) {
    throw Error("Elvish Error: local is not valid");
  }

  return ~_._apollo.imperial.countries.indexOf(country || _._country || countryFromLocal[0]);
}